// 반복영역 그룹 구분 칼럼 정규화 — 단수(deprecated `groupByCol`) ↔ 복수(`groupByCols`) 수용.
// 결정: docs/decisions/2026-07-13-table-repeat-group-multi-columns.md

import type { TableRepeatRegion } from '@safetyhub/shared';

/**
 * 반복영역의 유효 그룹 구분 칼럼 목록(0-based)을 계층 우선순위 순서로 반환한다.
 *  - `groupByCols`가 있으면 그것을 우선(순서 = 계층, 첫 번째 = 최상위).
 *  - 없으면 단수 `groupByCol`을 `[n]`으로 수용(저장 템플릿 하위호환).
 *  - 둘 다 없으면 `[]`(미사용).
 *
 * 음수/비정수/중복은 정리한다(순서 보존 dedupe). 저장 시엔 신형(`groupByCols`)으로 기록하되,
 * 렌더/UI 로드는 항상 이 헬퍼를 거쳐 두 형태를 동일하게 취급한다.
 */
export function effectiveGroupByCols(region: TableRepeatRegion): number[] {
  const raw =
    region.groupByCols && region.groupByCols.length > 0
      ? region.groupByCols
      : region.groupByCol !== undefined
        ? [region.groupByCol]
        : [];
  const out: number[] = [];
  for (const n of raw) {
    if (!Number.isInteger(n) || n < 0 || out.includes(n)) continue;
    out.push(n);
  }
  return out;
}
